module.exports = __webpack_public_path__ + "static/media/tachometer-light.30b90698.svg";